import { Component, Input } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * List page shell: optional gray **toolbar** strip (`[pageToolbar]`) + **white** table body,
 * or a single padded card when `[tableOnly]="true"` (no toolbar row).
 */
@Component({
  selector: 'app-page-body-panel',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-body-panel.component.html',
})
export class PageBodyPanelComponent {
  /** When `tableOnly` is false: padding on the white table section (toolbar has its own padding). */
  @Input() padded = true;
  /** No filter strip — one white card (e.g. integrations tables only). */
  @Input() tableOnly = false;
}
